(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('VendorsController', VendorsController);

  /* ngInject */
  function VendorsController($stateParams, $window, riskLevels, sessionService, vendorService, bannerService) {
    const vm = this;

    vm.currentPage = $stateParams.currentPage || 1;
    vm.filterResults = filterResults;
    vm.loading = false;
    vm.myVendorAssignments = [];
    vm.nameFilter = $stateParams.nameFilter || '';
    vm.pageChange = pageChange;
    vm.riskLevels = riskLevels;
    vm.riskLevelIdFilter = $stateParams.riskLevelIdFilter || null;
    vm.statusFilter = $stateParams.statusFilter || null;
    vm.totalCount = null;
    vm.vendors = [];
    vm.vendorSummary = {};
    vm.banners = [];
    vm.getBanners = getBanners;

    activate();

    function activate() {
      vm.getBanners();
      getVendors();
      getVendorSummary();
      getMyVendorAssignments();
    }

    function filterResults() {
      vm.vendors = [];
      vm.currentPage = 1;
      getVendors();
    }

    function getBanners() {
      bannerService(sessionService.getAuthToken()).query(response => vm.banners = response);
    }

    function getMyVendorAssignments() {
      vendorService(sessionService.getAuthToken()).my_assignments({}, response => {
        vm.myVendorAssignments = response;
      });
    }

    function getVendors() {
      vm.loading = true;

      let queryParams = {
        'q[name_cont]': vm.nameFilter,
        'q[risk_level_id_eq]': vm.riskLevelIdFilter,
        'q[status_eq]': vm.statusFilter,
        'page': vm.currentPage
      };
      vendorService(sessionService.getAuthToken()).query(queryParams, response => {
        vm.loading = false;
        vm.vendors = response.data;
        vm.totalCount = parseInt(response.headers['x-total']);
      }, _ => {
        vm.loading = false;
      });
    }

    function getVendorSummary() {
      vendorService(sessionService.getAuthToken()).summary(response => {
        vm.vendorSummary = response;
        initializePieChart();
      });
    }

    function initializePieChart() {
      new $window.Morris.Donut({
        element: 'vendor-summary-chart',
        data: [
          { label: 'Mission Critical', value: vm.vendorSummary['Mission Critical'] },
          { label: 'Major', value: vm.vendorSummary['Major'] },
          { label: 'Non-Critical', value: vm.vendorSummary['Non-Critical'] },
          { label: 'Potential', value: vm.vendorSummary['Potential'] },
          { label: 'Inactive', value: vm.vendorSummary['Inactive'] }
        ],
        colors: ['#d9534f', '#f0ad4e', '#337ab7', '#5bc0de', '#cccccc'],
        resize: true
      }); 
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.vendors = [];
      vm.currentPage = newPageNumber;
      getVendors();
    }
  }
})();
